import { Description, Dialog, DialogPanel, DialogTitle } from "@headlessui/react";
import { FunctionComponent, useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import {
  ButtonContainer,
  DoneButton,
  ErrorStyledContainer,
  ModalBackdrop,
  ModalContainer,
  StyledBigIcon,
  StyledDescription,
  StyledTitle,
} from "./styles";

import ErrorBall from "components/IconImage/errorBall";
import { configState, setLoader, setModal } from "state/config-slice";
import { AppDispatch } from "state/reducers-combiner";

const ErrorModal: FunctionComponent = () => {
  const { t } = useTranslation();
  const dispatch: AppDispatch = useDispatch();
  const currentConfig = useSelector(configState);
  const modal = currentConfig?.modal;

  const { title, description, customButtons, size, customFunction } = modal;

  const closeModal = useCallback(() => dispatch(setModal({ showModal: false })), [dispatch]);

  useEffect(() => {
    dispatch(setLoader({ showLoader: false, messageHeader: "", messageText: "" }));
  }, [dispatch]);

  const getDescription = () => {
    if (modal.errorCode === "AMAZON_PAYMENT_FAILED") {
      return t("You have insufficient funds to make this purchase. Please recharge your account and try again.");
    }

    return description ? t(description) : t("Please try again or reload the page");
  };

  const getTitle = () => {
    if (modal.errorCode === "AMAZON_PAYMENT_FAILED") {
      return t("Error");
    }

    return title ? t(title) : t("Oops! Technical error");
  };

  return (
    <Dialog open={modal.showModal} onClose={closeModal} as={ModalContainer} data-testid="error-modal">
      <ModalBackdrop data-testid="modal-backdrop" />

      <DialogPanel as={ErrorStyledContainer} type="error" size={size}>
        <StyledBigIcon>
          <ErrorBall />
        </StyledBigIcon>

        <DialogTitle as={StyledTitle}>{getTitle()}</DialogTitle>

        <Description
          as={StyledDescription}
          dangerouslySetInnerHTML={{
            __html: getDescription(),
          }}
        />

        <ButtonContainer>
          {customButtons || <DoneButton title={t("Done")} onClick={customFunction || closeModal} />}
        </ButtonContainer>
      </DialogPanel>
    </Dialog>
  );
};

export default ErrorModal;
